import { render, staticRenderFns } from "./AthleteCertificationSearch.vue?vue&type=template&id=5abad23e&scoped=true&"
import script from "./AthleteCertificationSearch.vue?vue&type=script&lang=js&"
export * from "./AthleteCertificationSearch.vue?vue&type=script&lang=js&"
import style0 from "./AthleteCertificationSearch.vue?vue&type=style&index=0&id=5abad23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abad23e",
  null
  
)

export default component.exports